import { checkAccess } from "~/utils/constants";
import { routeAccess } from "@/config";
export default function ({ store, redirect, route, }) {
  if (
    !(
      store.state.Auth.subscriptions &&
      store.state.Auth.subscriptions.legacy_permissions &&
      store.state.Auth.subscriptions.legacy_permissions.length > 0
    )
  ) {
      const requiredPermissionForPath = routeAccess
        .filter(el => route.path.startsWith(el.path))
        .map(el => el.permission);

    // Didn't find a required permission for path - default to allow access.
    if (requiredPermissionForPath.length === 0 ) return;

    let granted = false;
    if (store.state.Auth.subscriptions) {
      requiredPermissionForPath.forEach( el => {
        if(checkAccess(store.state.Auth.subscriptions.permissions, el)) {
          granted = true;
        }
      });
    }

    if(granted) return;

    return redirect("/access-denied");
  }

  // Add any additional routes to routeAccess object in config.js
}
